<template>
    <div>
        <b-row>
            <b-col cols="12" md="6" lg="6" v-if="!haveAClient">
                <div v-if="!edit">
                    <label for=""
                        >Cliente
                        <span class="field-required-mark">*</span></label
                    >
                    <app-autocomplete
                        placeholder="Cliente"
                        :items="clients"
                        v-model="theStore.selectedClient"
                        @change="startLoadVenues"
                        :hasError="$v.theStore.selectedClient.$error"
                        errorMessage="Debe seleccionar el cliente"
                    />
                </div>

                <div v-else>
                    <label>Cliente</label>
                    <app-sub-title
                        :text="
                            !!theStore.selectedClient
                                ? theStore.selectedClient.name
                                : ''
                        "
                    />
                </div>
            </b-col>
            <b-col align-h="center" cols="12" md="6" lg="6">
                <app-form-select-input
                    label="Sede"
                    :options="venues"
                    v-model="theStore.venueId"
                    :required="true"
                    :hasError="$v.theStore.venueId.$error"
                    errorMessage="Debe seleccionar la sede a la cual esta cerca el comercio"
                    @input="$v.theStore.venueId.$touch()"
                />
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <app-form-text-input
                    label="Nombre comercio"
                    id="name"
                    :required="true"
                    :hasError="$v.theStore.name.$error"
                    errorMessage="Debe escribir el nombre del comercio"
                    @input="$v.theStore.name.$touch()"
                    v-model="theStore.name"
                >
                </app-form-text-input>
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <app-form-text-input
                    label="Documento"
                    id="document"
                    v-model="theStore.document"
                >
                </app-form-text-input>
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <app-form-text-input
                    label="Dirección"
                    id="address"
                    v-model="theStore.address"
                >
                </app-form-text-input>
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <app-form-text-input
                    label="Sitio web"
                    id="website"
                    v-model="theStore.website"
                >
                </app-form-text-input>
            </b-col>
            <b-col cols="12" md="12" lg="12">
                <app-form-textarea-input
                    label="Especifique horarios. ej. L-V 8AM - 7PM"
                    id="availability"
                    v-model="theStore.availability"
                >
                </app-form-textarea-input>
            </b-col>
            <b-col cols="12" md="6" lg="6"> </b-col>
            <b-col cols="12" md="12" lg="12" v-if="!myStore">
                <label for="">Categoria (s) </label>
                <b-form-select
                    v-model="theStore.categories"
                    :options="categories"
                    multiple
                    :select-size="4"
                ></b-form-select>
                <div v-if="theStore.categories.length">
                    Seleccionados:
                    <label v-for="cat in theStore.categories" :key="cat.id">
                        {{ cat.name }} ,</label
                    >
                </div>
            </b-col>
            <b-col cols="12" v-if="!myStore">
                <br />
                <b-button
                    class="btn-block-xs-only"
                    v-b-toggle.collapse-2
                    variant="primary"
                    >Otra categoria</b-button
                >
                <b-collapse id="collapse-2" class="mt-2">
                    <b-card>
                        <p class="card-text">
                            <b-row>
                                <b-col cols="12" md="6" lg="6">
                                    <app-form-text-input
                                        placeholder="Nombre"
                                        id="newCategoryName"
                                        v-model="newCategory.name"
                                        :required="true"
                                        :hasError="$v.newCategory.name.$error"
                                        errorMessage="Debe escribir el nombre de la categoria"
                                        @input="$v.newCategory.name.$touch()"
                                    >
                                    </app-form-text-input>
                                </b-col>
                                <b-col cols="12" md="6" lg="3">
                                    <b-btn
                                        class="btn-block-xs-only"
                                        variant="primary"
                                        @click="addCategory"
                                        ><i
                                            class="fa fa-plus"
                                            aria-hidden="true"
                                        ></i>
                                        Agregar</b-btn
                                    >
                                </b-col>
                            </b-row>
                        </p>
                    </b-card>
                </b-collapse>
            </b-col>
            <b-col cols="12" v-if="!myStore">
                <br />
                <b-button
                    class="btn-block-xs-only"
                    v-b-toggle.collapse-1
                    variant="primary"
                    >Agregar teléfono</b-button
                >
                <b-collapse id="collapse-1" class="mt-2">
                    <b-card>
                        <p class="card-text">
                            <b-row>
                                <b-col cols="12" md="6" lg="5">
                                    <app-form-text-input
                                        placeholder="Nombre"
                                        id="phoneName"
                                        v-model="phone.name"
                                        :hasError="$v.phone.name.$error"
                                        :required="true"
                                        errorMessage="Debe escribir el nombre del contacto"
                                        @input="$v.phone.name.$touch()"
                                    >
                                    </app-form-text-input>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <app-form-text-input
                                        placeholder="Número"
                                        id="longitude"
                                        v-model="phone.number"
                                        :required="true"
                                        :hasError="$v.phone.number.$error"
                                        errorMessage="Debe escribir el número del contacto"
                                        @input="$v.phone.number.$touch()"
                                    >
                                    </app-form-text-input>
                                </b-col>
                                <b-col cols="12" md="6" lg="3">
                                    <b-btn
                                        class="btn-block-xs-only"
                                        variant="primary"
                                        @click="addPhone"
                                        ><i
                                            class="fa fa-plus"
                                            aria-hidden="true"
                                        ></i>
                                        Agregar</b-btn
                                    >
                                </b-col>
                                <b-col cols="12">
                                    <div v-for="oe in theStore.phones">
                                        <b-row>
                                            <b-col cols="5">
                                                {{ oe.name }} ({{ oe.number }})
                                            </b-col>
                                            <b-col cols="2">
                                                <b-btn
                                                    size="sm"
                                                    variant="outline-danger"
                                                    @click="removePhone(oe)"
                                                    ><i
                                                        class="fa fa-times"
                                                        aria-hidden="true"
                                                    ></i
                                                ></b-btn>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-col>
                            </b-row>
                        </p>
                    </b-card>
                </b-collapse>
            </b-col>
            <b-col cols="12">
                <br />
                <b-card
                    tag="article"
                    title="Ubicación"
                    style="max-width: 100%;"
                    class="mb-2"
                >
                    <div class="card-text">
                        <b-row>
                            <b-col cols="12" md="6" lg="6">
                                <app-form-text-input
                                    label="Latitud"
                                    id="latitude"
                                    v-model="theStore.latitude"
                                >
                                </app-form-text-input>
                            </b-col>
                            <b-col cols="12" md="6" lg="6">
                                <app-form-text-input
                                    label="longitud"
                                    id="longitude"
                                    v-model="theStore.longitude"
                                >
                                </app-form-text-input>
                            </b-col>
                            <b-col cols="12" md="6" lg="6">
                                <b-btn
                                    class="btn-block-xs-only"
                                    variant="primary"
                                    @click="getLocation"
                                    ><i
                                        class="fa fa-map-marker"
                                        aria-hidden="true"
                                    ></i>
                                    Obtener ubicación actual</b-btn
                                >
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
            <b-col cols="12" v-show="!myStore">
                <b-card
                    tag="article"
                    title="Foto del comercio"
                    style="max-width: 100%;"
                    class="mb-2"
                >
                    <div class="card-text">
                        <b-form-file
                            required
                            v-model="theStore.file"
                            :state="Boolean(theStore.file)"
                            placeholder="Seleccione imagen"
                            accept=".jpg, .jpeg, .png"
                            ref="fileinput"
                        ></b-form-file>
                        <div v-if="theStore.file" class="mt-3">
                            Archivo seleccionado:
                            {{ theStore.file && theStore.file.name }}
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-card
            title="Información del contacto principal"
            tag="article"
            style="max-width: 100%;"
            class="mb-2"
        >
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="6" lg="6">
                        <app-form-text-input
                            label="Nombre"
                            id="nameContact"
                            v-model="theStore.primaryContactName"
                        >
                        </app-form-text-input>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <app-form-text-input
                            label="Teléfono"
                            id="primaryContactPhone"
                            v-model="theStore.primaryContactPhone"
                        >
                        </app-form-text-input>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <app-form-text-input
                            label="E-Mail"
                            id="primaryContactEmail"
                            v-model="theStore.primaryContactEmail"
                            :hasError="$v.theStore.primaryContactEmail.$error"
                            errorMessage="Debe escribir un e-mail valido"
                            @input="$v.theStore.primaryContactEmail.$touch()"
                        >
                        </app-form-text-input>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import Autocomplete from "../../../UI/Controls/AutocompleteV2/Autocomplete.vue";
import storesRepository from "../../../../repositories/stores.repository";
import clientsRepository from "../../../../repositories/clients.repository.js";
import { required, email } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
    components: {
        appAutocomplete: Autocomplete
    },
    props: {
        id: {
            required: true
        },
        myStore: {
            type: Object,
            required: false
        },
        onSave: {
            type: Function
        },
        edit: {
            type: Boolean,
            default: () => false
        }
    },
    // watch: {
    //     myStore(val){
    //         this.fillForm();
    //     }
    // },
    computed: {
        ...mapGetters(["clients"])
    },
    data() {
        return {
            theStore: {
                userId: "",
                venueId: "",
                name: "",
                document: "",
                address: "",
                website: "",
                availability: "",
                longitude: "",
                latitude: "",
                primaryContactName: "",
                primaryContactPhone: "",
                primaryContactEmail: "",
                selectedClient: "",
                file: "",
                phones: [],
                categories: []
            },
            phone: {
                name: "",
                number: ""
            },
            newCategory: {
                name: ""
            },
            venues: [],
            categories: []
        };
    },
    watch: {
        edit(val) {
            this.updateForm(val);
        }
    },

    validations() {
        let theStore;
        let phone;
        let newCategory;
        if (!this.haveAClient) {
            (theStore = {
                venueId: { required },
                name: { required },
                selectedClient: { required },
                primaryContactEmail: { email }
            }),
                (phone = {
                    name: { required },
                    number: { required }
                }),
                (newCategory = {
                    name: { required }
                });
        } else {
            (theStore = {
                venueId: { required },
                name: { required },
                primaryContactEmail: { email }
            }),
                (phone = {
                    name: { required },
                    number: { required }
                }),
                (newCategory = {
                    name: { required }
                });
        }
        return { theStore, phone, newCategory };
    },
    methods: {
        updateForm(edit) {
            if (edit) {
                this.fillForm();
            } else {
                this.cleanFields();
                if (this.haveAClient) {
                    this.theStore.selectedClient = this.client;
                    this.startLoadVenues();
                }
            }
        },
        getLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    this.theStore.latitude = position.coords.latitude + "";
                    this.theStore.longitude = position.coords.longitude + "";
                });
            }
        },
        addPhone() {
            this.$v.phone.$touch();
            if (this.$v.phone.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }
            this.theStore.phones.push(this.phone);
            this.phone = {};
            this.$v.phone.$reset();
        },
        removePhone(phone) {
            const i = this.theStore.phones.indexOf(phone);
            this.theStore.phones.splice(i, 1);
            toastr.success("Teléfono eliminado");
        },
        addCategory() {
            this.$v.newCategory.$touch();
            if (this.$v.newCategory.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }
            this.newCategory.isNew = 1;
            this.theStore.categories.push(this.newCategory);
            this.newCategory = {};
            this.$v.newCategory.$reset();
        },
        startLoadVenues() {
            if (!this.theStore.selectedClient && !this.edit) return;
            !!this.$v.theStore.selectedClient
                ? this.$v.theStore.selectedClient.$touch()
                : "";
            this.loadVenues(this.theStore.selectedClient.id);
        },
        loadVenues(clientId) {
            const cr = { ...clientsRepository };
            cr.getVenuesByClient(clientId)
                .then(data => (this.venues = data))
                .catch(error =>
                    toastr.error("Error al cargar las sedes del cliente")
                );
        },
        loadCategories() {
            const sr = { ...storesRepository };
            sr.loadStoreCategories()
                .then(({ data }) => {
                    data.map(item => {
                        const object = {
                            text: item.name,
                            value: item,
                            isNew: 0
                        };
                        this.categories.push(object);
                    });
                })
                .catch(error =>
                    toastr.error("Error al cargar las categorias de tienda")
                );
        },
        saveStore() {
            this.$v.theStore.$touch();
            if (this.$v.theStore.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            const formData = new FormData();

            formData.append("clientId", this.theStore.selectedClient.id);
            formData.append("venueId", this.theStore.venueId);
            formData.append("userId", this.user.id);
            formData.append("name", this.theStore.name);
            formData.append("address", this.theStore.address);
            formData.append("website", this.theStore.website);
            formData.append("document", this.theStore.document);
            formData.append("availability", this.theStore.availability);
            formData.append("longitude", this.theStore.longitude);
            formData.append("latitude", this.theStore.latitude);
            formData.append(
                "primaryContactName",
                this.theStore.primaryContactName
            );
            formData.append(
                "primaryContactPhone",
                this.theStore.primaryContactPhone
            );
            formData.append(
                "primaryContactEmail",
                this.theStore.primaryContactEmail
            );

            if (!!this.theStore.phones.length) {
                this.theStore.phones.forEach((item, index) => {
                    Object.keys(item).forEach(key =>
                        formData.append(`phones[${index}][${key}]`, item[key])
                    );
                });
            }

            if (!!this.theStore.categories.length) {
                this.theStore.categories.forEach((item, index) => {
                    if (item.isNew) {
                        item.isNew = 1;
                    } else {
                        item.isNew = 0;
                    }
                    Object.keys(item).forEach(key =>
                        formData.append(
                            `categories[${index}][${key}]`,
                            item[key]
                        )
                    );
                });
            }

            if (this.theStore.file) {
                formData.append("file", this.theStore.file);
            }

            const sr = { ...storesRepository };
            sr.saveStore(formData)
                .then(({ data }) => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.categories = [];
                        this.loadCategories();
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Error al guardar el comercio");
                });
        },
        updateStore() {
            this.$v.theStore.$touch();
            if (this.$v.theStore.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            const payload = {};
            payload["clientId"] = this.theStore.selectedClient.id;
            payload["venueId"] = this.theStore.venueId;
            payload["name"] = this.theStore.name;
            payload["address"] = this.theStore.address;
            payload["website"] = this.theStore.website;
            payload["document"] = this.theStore.document;
            payload["availability"] = this.theStore.availability;
            payload["longitude"] = this.theStore.longitude;
            payload["latitude"] = this.theStore.latitude;
            payload["primaryContactName"] = this.theStore.primaryContactName;
            payload["primaryContactPhone"] = this.theStore.primaryContactPhone;
            payload["primaryContactEmail"] = this.theStore.primaryContactEmail;

            this.theStore.clientId;

            const sr = { ...storesRepository };
            sr.updateStore(payload, this.myStore.id)
                .then(({ data }) => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.categories = [];
                        this.loadCategories();
                        typeof this.onSave === "function" &&
                            this.onSave(data.store);
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Error al modificar el comercio");
                });
        },
        saveOrUpdate() {
            if (!!this.myStore) {
                this.updateStore();
            } else {
                this.saveStore();
            }
        },
        fillForm() {
            if (Object.keys(this.myStore).length !== 0) {
                this.theStore.selectedClient = this.myStore.client;
                this.theStore.userId = this.myStore.user_id;
                this.theStore.venueId = this.myStore.venue_id;
                this.theStore.name = this.myStore.name;
                this.theStore.address = this.myStore.address;
                this.theStore.website = this.myStore.website;
                this.theStore.document = this.myStore.document;
                this.theStore.availability = this.myStore.availability;
                this.theStore.longitude = this.myStore.longitude;
                this.theStore.latitude = this.myStore.latitude;
                this.theStore.primaryContactName = this.myStore.primary_contact_name;
                this.theStore.primaryContactEmail = this.myStore.primary_contact_email;
                this.theStore.primaryContactPhone = this.myStore.primary_contact_phone;
                this.theStore.categories = this.myStore.store_categories;
                this.theStore.phones = this.myStore.store_phones;

                this.venues = this.theStore.selectedClient.venues;
            } else {
                this.cleanFields();
            }
        },
        cleanFields() {
            Object.keys(this.theStore).map(key => (this.theStore[key] = ""));
            this.theStore.categories = [];
            this.theStore.phones = [];
            this.venues = [];
            this.$refs.fileinput.reset();
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        initialize() {
            !this.edit && this.load("clients");
            this.loadCategories();
        }
    },
    created() {
        this.initialize();
        this.haveAClient = !!this.client ? true : false;
        if (this.haveAClient) {
            this.theStore.selectedClient = this.client;
            this.startLoadVenues();
        }
        this.$bus.$off(this.id + ".save");
        this.$bus.$off(this.id + ".clean");
    },
    mounted() {
        this.updateForm(this.edit);
        this.$bus.$on(this.id + ".save", this.saveOrUpdate);
        this.$bus.$on(this.id + ".clean", this.cleanFields);
    }
};
</script>
<style>
.custom-file-input:lang(es) ~ .custom-file-label::after {
    content: "Buscar";
}
</style>
